import _ from 'lodash'
import React, { PureComponent } from 'react'

import { createStyles, TextField, Theme } from '@mui/material'
import { withStyles, WithStyles } from '@mui/styles'

class OrganizationTextFilter extends PureComponent<OrganizationTextFilterProps & WithStyles<typeof styles>> {
  constructor(props: OrganizationTextFilterProps & WithStyles<typeof styles>) {
    super(props)
    this.handleSearchChange = this.handleSearchChange.bind(this)
    this.propagateChange = _.debounce(this.propagateChange.bind(this), 250)
  }

  handleSearchChange(event: React.ChangeEvent<HTMLInputElement>) {
    this.propagateChange(event.target.value)
  }

  // We need to encapsulate the change, since event.target doesn't play well with debouncing
  propagateChange(search: string) {
    const { onChangeSearch } = this.props
    onChangeSearch(search)
  }

  render() {
    const { classes, searchField } = this.props
    if (searchField !== undefined) {
      this.propagateChange(searchField)
    }
    return (
      <TextField
        placeholder="Company name or id"
        // Inheriting the value from the redux store seems to be slow, we can use the local state here for performance reasons
        // value={search}
        onChange={this.handleSearchChange}
        className={classes.field}
        value={this.props.searchField}
      />
    )
  }
}

export type OrganizationTextFilterProps = {
  search: string
  searchField: string
  onChangeSearch: (newSearch: string) => void
}

const styles = ({ spacing }: Theme) =>
  createStyles({
    field: {
      width: spacing(38),
      marginRight: spacing(2),
    },
  })

export default withStyles(styles)(OrganizationTextFilter)
